import { Office, OfficeAttributes, Meta } from "typings";
import { Dispatch } from "redux";
import { Offices } from "@pacerpro/api";

/////////////////////////////////////////////////
// OFFICE CONSTANTS
/////////////////////////////////////////////////

export const SET_OFFICES = "SET_OFFICES";
export const SET_EMPTY_OFFICE = "SET_EMPTY_OFFICE";
export const ADD_OFFICE = "ADD_OFFICE";
export const EDIT_OFFICE = "EDIT_OFFICE";
export const DELETE_OFFICE = "DELETE_OFFICE";

/////////////////////////////////////////////////
// OFFICE ACTIONS
/////////////////////////////////////////////////

export const setOffices = (payload: {
  data: Office[];
  included?: any[];
  meta: Meta;
}) => ({
  type: SET_OFFICES,
  payload,
});

export const setEmptyOffice = (payload: {}) => ({
  type: SET_EMPTY_OFFICE,
  payload,
});

export const addNewOffice = (attributes: OfficeAttributes) => async (
  dispatch: Dispatch,
) => {
  try {
    const officeResponse = await Offices.create(attributes);
    dispatch({
      type: ADD_OFFICE,
      payload: officeResponse.data.data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const editOfficeInTable = (
  officeId: string,
  attributes: OfficeAttributes,
) => async (dispatch: Dispatch) => {
  try {
    const officeResponse = await Offices.edit(officeId, attributes);
    dispatch({
      type: EDIT_OFFICE,
      payload: officeResponse.data.data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const deleteOffice = (officeId: string) => async (
  dispatch: Dispatch,
) => {
  try {
    await Offices.remove(officeId);
    dispatch({
      type: DELETE_OFFICE,
      payload: officeId,
    });
  } catch (error) {
    console.error(error);
  }
};

export type OfficesAction =
  | {
      type: typeof SET_OFFICES;
      payload: {
        data: Office[];
        included?: any[];
        meta: Meta;
      };
    }
  | {
      type: typeof SET_EMPTY_OFFICE;
      payload: {};
    }
  | {
      type: typeof ADD_OFFICE;
      payload: Office;
    }
  | {
      type: typeof EDIT_OFFICE;
      payload: Office;
    }
  | {
      type: typeof DELETE_OFFICE;
      payload: string;
    };

/////////////////////////////////////////////////
// OFFICE LIST REDUCER
/////////////////////////////////////////////////

export interface OfficesState {
  offices: {
    data: Office[];
    included?: any[];
    meta: Meta;
  };
}

const initialState: OfficesState = {
  offices: {
    data: [],
    included: [],
    meta: {
      recordCount: 0,
      pageCount: 0,
    },
  },
};

export default (state = initialState, action: OfficesAction) => {
  switch (action.type) {
    case SET_OFFICES: {
      return {
        ...state,
        offices: {
          data: action.payload.data,
          included: action.payload.included,
          meta: action.payload.meta,
        },
      };
    }
    case SET_EMPTY_OFFICE: {
      return {
        ...state,
        offices: {
          ...state.offices,
          data: [action.payload, ...state.offices.data],
        },
      };
    }
    case ADD_OFFICE: {
      return {
        ...state,
        offices: {
          ...state.offices,
          data: state.offices.data.map((office: any) =>
            office.status === "new" ? action.payload : office,
          ),
        },
      };
    }
    case EDIT_OFFICE: {
      return {
        ...state,
        offices: {
          ...state.offices,
          data: state.offices.data.map(office =>
            office.id === action.payload.id ? action.payload : office,
          ),
        },
      };
    }
    case DELETE_OFFICE: {
      return {
        ...state,
        offices: {
          ...state.offices,
          data: state.offices.data.filter(
            office => office.id !== action.payload,
          ),
        },
      };
    }
    default:
      return state;
  }
};
